import React from 'react';

// Reuses the ToggleConfig .switch / .slider.round markup from Config.js.
const BooleanField = ({ field, value, onChange, disabled }) => (
  <label className={disabled ? 'switch disabled' : 'switch'}>
    <input
      type="checkbox"
      checked={!!value}
      disabled={disabled}
      onChange={() => {
        if (disabled) return;
        onChange(field.key, !value);
      }}
    />
    <span className="slider round" />
  </label>
);

export default BooleanField;
